(function(){
  'use strict';

  // -------- TL;DR callout: move below first paragraph (perex) --------
  (function moveTldr(){
    var article = document.querySelector('.post-body');
    if (!article) return;
    var tldr = article.querySelector(':scope > .tldr');
    if (!tldr) return;
    for (var i = 0; i < article.children.length; i++) {
      var el = article.children[i];
      if (el.tagName === 'P') {
        if (el.nextSibling) article.insertBefore(tldr, el.nextSibling);
        else article.appendChild(tldr);
        break;
      }
    }
  })();

  // -------- Reading progress bar --------
  var bar = document.querySelector('.progress');
  if (bar) {
    var raf = null;
    function tick(){
      raf = null;
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var pct = max > 0 ? (h.scrollTop / max) * 100 : 0;
      bar.style.width = pct.toFixed(2) + '%';
    }
    function schedule(){ if (!raf) raf = window.requestAnimationFrame(tick); }
    document.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    tick();
  }

  // -------- Copy permalink button --------
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-copy-link]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-copy-link') || window.location.href;
    var done = function(){
      var orig = btn.textContent;
      btn.textContent = '✓';
      setTimeout(function(){ btn.textContent = orig; }, 1400);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function(){
        fallbackCopy(url); done();
      });
    } else {
      fallbackCopy(url); done();
    }
  });

  function fallbackCopy(text){
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch(_){}
    document.body.removeChild(ta);
  }

  // -------- Member signup form (Ghost) --------
  // Replaces the form area with a branded success card on submit.
  var forms = document.querySelectorAll('form[data-members-form]');
  forms.forEach(function(form){
    form.addEventListener('submit', function(ev){
      ev.preventDefault();
      ev.stopPropagation();
      // Double-submit guard
      if (form.dataset.submitting === '1') return;

      var state = form.closest('.sub-state');
      var msg = state ? state.querySelector('.sub-msg') : null;
      var emailEcho = state ? state.querySelector('.sub-email') : null;
      var emailInput = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button[type="submit"]');
      if (!emailInput || !emailInput.value) return;
      var email = emailInput.value.trim();

      form.dataset.submitting = '1';
      if (msg) { msg.textContent = 'Odesílám…'; msg.classList.remove('is-error'); }
      if (state) state.setAttribute('data-state', 'loading');
      if (btn) btn.disabled = true;

      fetch('/members/api/send-magic-link/', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({email: email, emailType: 'signup', labels: []})
      }).then(function(res){
        if (!res.ok) throw new Error('signup failed (' + res.status + ')');
        if (emailEcho) emailEcho.textContent = email;
        if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
        if (state) {
          state.setAttribute('data-state', 'success');
          // Move focus to success heading for screen readers
          var h3 = state.querySelector('.sub-success h3');
          if (h3) { try { h3.focus(); } catch(_){} }
        }
      }).catch(function(){
        if (state) state.setAttribute('data-state', 'idle');
        if (btn) btn.disabled = false;
        if (msg) {
          msg.textContent = 'Něco se pokazilo. Zkus to prosím znovu za chvíli.';
          msg.classList.add('is-error');
        }
      }).finally(function(){
        delete form.dataset.submitting;
      });
    });
  });

  // -------- Subscribe: "Zkusit jiný email" reset --------
  document.addEventListener('click', function(e){
    var rst = e.target.closest('.sub-reset');
    if (!rst) return;
    e.preventDefault();
    var state = rst.closest('.sub-state');
    if (!state) return;
    var subForm = state.querySelector('form[data-members-form]');
    var input = subForm ? subForm.querySelector('input[type="email"]') : null;
    var btn = subForm ? subForm.querySelector('button[type="submit"]') : null;
    var msg = state.querySelector('.sub-msg');
    state.setAttribute('data-state', 'idle');
    if (subForm) subForm.reset();
    if (btn) btn.disabled = false;
    if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
    if (input) { setTimeout(function(){ try { input.focus(); } catch(_){} }, 50); }
  });

  // -------- Wrap post-body tables for horizontal scroll on narrow screens --------
  var tables = document.querySelectorAll('.post-body table');
  tables.forEach(function(table){
    if (table.parentNode && table.parentNode.classList.contains('table-scroll')) return;
    var wrap = document.createElement('div');
    wrap.className = 'table-scroll';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);

    function update(){
      var max = wrap.scrollWidth - wrap.clientWidth;
      if (max <= 1) { wrap.setAttribute('data-scroll', 'none'); return; }
      var x = wrap.scrollLeft;
      var atStart = x <= 1;
      var atEnd = x >= max - 1;
      wrap.setAttribute('data-scroll', atEnd ? 'end' : (atStart ? 'start' : 'middle'));
    }
    wrap.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    update();
  });

  // -------- Hide-on-scroll-down sticky header (mobile, all pages) --------
  var stickyHeader = document.querySelector('.site-header');
  var nav = document.querySelector('.subnav');
  if (stickyHeader) {
    var lastY = window.scrollY;
    var ticking = false;
    function onScroll(){
      var y = window.scrollY;
      if (Math.abs(y - lastY) < 4) { ticking = false; return; }
      // Never slide the header away while the nav is hanging off it
      if (nav && nav.classList.contains('is-open')) {
        stickyHeader.classList.remove('is-hidden');
      } else if (y < 100) {
        stickyHeader.classList.remove('is-hidden');
      } else if (y > lastY) {
        stickyHeader.classList.add('is-hidden');
      } else {
        stickyHeader.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, {passive:true});
  }

  // -------- Mobile nav toggle (if present) --------
  var navToggle = document.querySelector('[data-nav-toggle]');
  if (navToggle && nav) {
    var setOpen = function(open){
      nav.classList.toggle('is-open', open);
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      navToggle.setAttribute('aria-label', open ? 'Zavřít menu' : 'Otevřít menu');
      if (open && stickyHeader) stickyHeader.classList.remove('is-hidden');
    };
    navToggle.addEventListener('click', function(){
      setOpen(!nav.classList.contains('is-open'));
    });
    nav.querySelectorAll('.nav-menu a').forEach(function(a){
      a.addEventListener('click', function(){ setOpen(false); });
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && nav.classList.contains('is-open')) setOpen(false);
    });
  }

  // Native #anchor jump doesn't fire reliably here (html overflow:clip + late images),
  // so scroll to the hash target once the page has loaded (e.g. nav "Insighty" -> /#insighty).
  window.addEventListener('load', function(){
    if (!location.hash || location.hash.charAt(1) === '/') return; // "#/search" etc. belong to Ghost Portal
    var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (target) target.scrollIntoView({behavior: 'instant', block: 'start'});
  });

})();
